import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { useGoogleLogin } from '@react-oauth/google';
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { useNavigate } from "react-router-dom";
import { handleErrors, scrollToView, showToaster } from "components/Common/common";
import { PAGEPATHS } from "components/Common/Constant";
import { useState } from "react";
import SelectOrganization from "./SelectOrg";
import axios from "axios";

const GoogleSignupComp = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [openOrgSelector, setOpenOrgSelector] = useState(false);
    const [accessToken, setAccessToken] = useState('');

    const navigate = useNavigate();

    // After org selected → SIGNUP (no auto-login — pending admin approval)
    const signupAfterOrgCreation = async (orgId, token) => {
        try {
            const payload = {
                token: accessToken || token,
                orgId
            };

            const { data } = await axiosInstance.post(ApiNames.GOOGLE_SIGNUP, payload);

            if (data.status === 1) {
                showToaster(1, data.message || 'Account created successfully. Please wait for administrator approval.');
                navigate(PAGEPATHS.Login);
            } else {
                showToaster(0, data.message);
            }

        } catch (error) {
            handleErrors(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoogleSignupSuccess = async (response) => {
        console.log("Google Response:", response);
        try {
            setIsLoading(true);
            setAccessToken(response.access_token);

            // Check if user already exists
            const { data } = await axios.post(
                ApiNames.GOOGLE_EXIST,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${response.access_token}`
                    }
                }
            );

            // Existing user — redirect to login
            if (data.status === 1) {
                showToaster(0, "Account already exists. Please login with Google.");
                navigate(PAGEPATHS.Login);
                return;
            }

            // New user → ask org
            setOpenOrgSelector(true);
            scrollToView('google-signup');

        } catch (error) {
            // user not found (404) → allow signup
            if (error.response && error.response.status === 404) {
                setOpenOrgSelector(true);
                scrollToView('google-signup');
            } else {
                handleErrors(error);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const signup = useGoogleLogin({
        onSuccess: handleGoogleSignupSuccess,
        onError: (error) => handleErrors(error)
    });

    return (
        <div style={{ placeSelf: 'center', width: '100%', marginTop: '16px' }}>
            <div className="hr-container">
                <span>Or</span>
            </div>

            {openOrgSelector &&
                <SelectOrganization
                    loginAfterOrgCreation={signupAfterOrgCreation}
                />
            }

            <button
                id="google-signup"
                disabled={isLoading}
                className={`login-w-g ${isLoading && 'pe-none'}`}
                onClick={signup}
            >
                {isLoading && <div className="loader-container"></div>}

                <svg
                    style={{ filter: `grayscale(${isLoading ? '1' : '0'})` }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    role="img"
                    className="icon"
                >
                    <path fillRule="evenodd" clipRule="evenodd" d="M17.64 9.20419C17.64 8.56601 17.5827 7.95237 17.4764 7.36328H9V10.8446H13.8436C13.635 11.9696 13.0009 12.9228 12.0477 13.561V15.8192H14.9564C16.6582 14.2524 17.64 11.9451 17.64 9.20419Z" fill="#4285F4"></path>
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.99976 18C11.4298 18 13.467 17.1941 14.9561 15.8195L12.0475 13.5613C11.2416 14.1013 10.2107 14.4204 8.99976 14.4204C6.65567 14.4204 4.67158 12.8372 3.96385 10.71H0.957031V13.0418C2.43794 15.9831 5.48158 18 8.99976 18Z" fill="#34A853"></path>
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.96409 10.7098C3.78409 10.1698 3.68182 9.59301 3.68182 8.99983C3.68182 8.40664 3.78409 7.82983 3.96409 7.28983V4.95801H0.957273C0.347727 6.17301 0 7.54755 0 8.99983C0 10.4521 0.347727 11.8266 0.957273 13.0416L3.96409 10.7098Z" fill="#FBBC05"></path>
                    <path fillRule="evenodd" clipRule="evenodd" d="M8.99976 3.57955C10.3211 3.57955 11.5075 4.03364 12.4402 4.92545L15.0216 2.34409C13.4629 0.891818 11.4257 0 8.99976 0C5.48158 0 2.43794 2.01682 0.957031 4.95818L3.96385 7.29C4.67158 5.16273 6.65567 3.57955 8.99976 3.57955Z" fill="#EA4335"></path>
                </svg>
                <span className={`${isLoading ? 'text-white' : ''}`}>
                    Sign up with Google
                </span>
            </button>
        </div>
    );
};

export default GoogleSignupComp;
